import React, { useContext, useEffect } from 'react'
import { Button, Modal, ModalContent, ModalHeader, Suspense, useFetch } from 'journey-ui'
import { ItemPageContext } from '../../contexts/ItemPageContext'
import { TileModalToppingBtn } from './TileModalToppingBtn'
import { useToppingPriceUpdater } from '../../hooks/useToppingPriceUpdater'

interface Props {

}

export const TileModal: React.FC<Props> = () => {
  const { form, item, rules, tileModal, setTileModal } = useContext(ItemPageContext)
  const isOpen = !!tileModal
  const updateToppingPrices = useToppingPriceUpdater()

  const [tileToppings = [], setTileToppings, tileToppingFetcher] = useFetch<SectionTopping[]>({
    url: `/api/tile/${tileModal?.hash_id}/topping?size_name=${encodeURIComponent(form.size_name)}&recipe_name=${encodeURIComponent(item.name)}`,
    isAllowed: isOpen,
    formatResponse: (resp) => updateToppingPrices(resp.data),
  })

  const { refresh } = tileToppingFetcher

  /* If we add/remove any topping, refetch the tile toppings so we can apply new pricing. */
  useEffect(() => {
    refresh()
  }, [form.toppings, refresh])

  const toppingNames = getToppingNames(tileToppings)

  return (
    <Modal isOpen={isOpen} onClose={() => setTileModal(undefined)}>
      <ModalHeader>
        {tileModal?.name}
      </ModalHeader>
      <ModalContent className="max-h-screen-1/2 overflow-y-auto">
        <Suspense hook={tileToppingFetcher}>
          {toppingNames.map((toppingName) => <TileModalToppingBtn key={toppingName} tileToppings={tileToppings as any} tile={tileModal} toppingName={toppingName} />)}
        </Suspense>
      </ModalContent>
      <div className="w-full h-16 flex justify-center items-center bg-panel">
        <Button className="primary" onClick={() => setTileModal(undefined)}>
          Close
        </Button>
      </div>
    </Modal>
  )
}

function getToppingNames(toppings: ItemTopping[] | SectionTopping[]): string[] {
  const obj = {}

  toppings.sort((a, b) => a.price - b.price).forEach((topping) => {
    obj[topping.name] = true
  })

  return Object.keys(obj)
}
